import { Button, Typography } from "@material-ui/core"
import { ContactUs, HomePageCarStrip, ShowRoom, postContactContact } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { trackPersonalDetails, trackSuccessContacUs } from "common/analytics"
import FormikForm from "common/bit/form/FormikForm"
import { getUtmParamsAsKeyValueList } from "common/bit/utils/utmParams"
import { postCallboxLead } from "common/postCallboxLead"
import { FormikProps } from "formik"
import { useRouter } from "next/dist/client/router"
import { useEffect, useRef, useState } from "react"
import FormInput from "reusable/formsComp/FormInput"
import FormSelect, { toFormSelectOptions } from "reusable/formsComp/FormSelect"
import FormSuccessState from "reusable/formsComp/FormSuccessState"
import FormCheckBoxWithLable from "reusable/formsComp/checkbox/FormCheckBoxWithLable"
import ErrorInFormPopup from "reusable/popups/ErrorInFormPopup"
import InnerPageWrapper from "reusable/wrappers/InnerPageWrapper"
import styled from "styled-components"
import ContactLinks from "./ContactLinks"
import schemaContactUs, { initialFormStatesContactUs } from "./SchemaContactUs"

// Subject enum for contact reasons
export enum ContactSubject {
  BuyCar = "קניית רכב",
  Service = "שירות",
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .MuiFormControlLabel-root {
    margin-right: 0px;
  }
`
const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 660px;
  }
`
const StyledButton = styled(Button)`
  margin: 20px 0px;
`

const StyledRowCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 2px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    column-gap: 16px;
  }
`

const StyledWrap = styled.div`
  width: 100%;
  max-width: 320px;
`
const StyledRequiredFields = styled(Typography).attrs({ variant: "body2" })`
  color: ${(p) => p.theme.colors.mazdaRed};
  margin-left: auto;
`
const StyledSelectWrap = styled.div<{ $aloneInRow }>`
  ${(p) => p.theme.breakpoints.up("md")} {
    ${(p) =>
      p.$aloneInRow
        ? `width: calc(50% - 8px); margin-left: auto;`
        : "width: 100%;"}
  }
`
// form status enum
export enum FormStatus {
  Normal = "normal",
  Success = "success",
  Error = "error",
}

type Props = {
  showRoomsList: ShowRoom[]
  modelsList: HomePageCarStrip[]
}

const ContactUsPage = ({ modelsList, showRoomsList }: Props) => {
  const [firstChangeService, setFirstChangeService] = useState(false)
  const [firstChangeSales, setFirstChangeSales] = useState(false)
  const [formStatus, setFormStatus] = useState<FormStatus>(FormStatus.Normal)
  const isDesktop = useIsDesktop()
  const showRoomsOptions = toFormSelectOptions(showRoomsList, "id", "name")
  const modelsOptions = toFormSelectOptions(
    modelsList.filter((model) => model.carState === "Available"),
    "id",
    "name"
  )
  const formikRef = useRef<FormikProps<typeof initialFormStatesContactUs>>()
  const router = useRouter()

  useEffect(() => {
    setFormStatus(FormStatus.Normal)
  }, [router])

  // Set subject from URL search param if present
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const subjectParam = params.get("subject")
    if (
      subjectParam &&
      Object.values(ContactSubject).includes(subjectParam as ContactSubject) &&
      formikRef.current
    ) {
      formikRef.current.setFieldValue("subject", subjectParam)
    }
  }, [])

  return (
    <>
      <InnerPageWrapper
        title="זמינים בשבילך"
        subtitle="מהצעד הראשון ולאורך כל הדרך, צוות השירות שלנו כאן לכל שאלה ועניין"
        imgUrl={
          isDesktop
            ? "/img/cover/contactus.jpg"
            : "/img/cover/contactusmobile.jpg"
        }
        breadCrumbName="ContactUs"
      >
        <>
          <StyledWrapper>
            {formStatus === FormStatus.Success && <FormSuccessState />}
            {(formStatus === FormStatus.Error ||
              formStatus === FormStatus.Normal) && (
              <FormikForm
                innerRef={formikRef}
                validationSchema={schemaContactUs}
                initialValues={initialFormStatesContactUs}
                onSubmit={async (values) => {
                  const utmValues = getUtmParamsAsKeyValueList()

                  const request: ContactUs = {
                    subjectId:
                      values?.subject === ContactSubject.BuyCar ? 1 : 2,
                    licensePlate: values?.licenseNumber,
                    carModelId: values?.model ? parseInt(values?.model) : 0,
                    showRoomId: values?.showRoom
                      ? parseInt(values?.showRoom)
                      : 0,
                    firstName: values?.firstName,
                    lastName: values?.lastName,
                    phone: values?.phoneNumber,
                    fax: "",
                    email: values?.email,
                    otherPhone: "",
                    description: values?.message,
                    approveMailingList: values?.approveMailingList,
                    contactSource: isDesktop ? "Pc" : "Mobile",
                    utmValues,
                    sid: window?.__ctm?.config?.sid || "",
                    formName: "Mazda_contactus_form",
                  }

                  const formResponse = await postContactContact(request)
                  postCallboxLead("contact", request)

                  if (formResponse?.data) {
                    trackSuccessContacUs(
                      values?.subject,
                      "contact_us_lead_success"
                    )
                    trackPersonalDetails(
                      "ContactUs",
                      values.email,
                      values.phoneNumber,
                      false
                    )
                    setFormStatus(FormStatus.Success)
                  } else {
                    setFormStatus(FormStatus.Error)
                  }
                }}
                render={(formik) => (
                  <StyledFormDiv>
                    <StyledRequiredFields>* שדות חובה</StyledRequiredFields>
                    <StyledRowCol>
                      <StyledSelectWrap
                        $aloneInRow={
                          formik.values.subject === ContactSubject.BuyCar
                        }
                      >
                        <FormSelect
                          name="subject"
                          required
                          label="נושא הפנייה"
                          values={Object.values(ContactSubject)}
                          map={(item) => ({ id: item, name: item })}
                          onChange={(e) => {
                            formik.setFieldValue("subject", e.target.value)
                            if (
                              e.target.value === ContactSubject.Service &&
                              !firstChangeService
                            ) {
                              setFirstChangeService(true)
                            }

                            if (
                              e.target.value === ContactSubject.BuyCar &&
                              !firstChangeSales
                            ) {
                              setFirstChangeSales(true)
                            }
                          }}
                          focused={
                            !formik.isSubmitting && formik.errors.subject
                              ? true
                              : false
                          }
                        />
                      </StyledSelectWrap>
                      {formik.values.subject !== ContactSubject.BuyCar && (
                        <FormInput
                          name="licenseNumber"
                          label="מספר לוחית רישוי"
                          required
                        />
                      )}
                    </StyledRowCol>
                    {formik.values.subject === ContactSubject.BuyCar && (
                      <StyledRowCol>
                        <FormSelect
                          name="model"
                          required
                          label="דגם רכב"
                          values={modelsOptions}
                          map={(item) => ({ id: item.id, name: item.name })}
                        />

                        <FormSelect
                          name="showRoom"
                          required
                          label="אולם תצוגה"
                          values={showRoomsOptions}
                          map={(item) => ({ id: item.id, name: item.name })}
                        />
                      </StyledRowCol>
                    )}
                    <StyledRowCol>
                      <FormInput
                        name="firstName"
                        label="שם פרטי"
                        required
                        autoComplete="given-name"
                      />
                      <FormInput
                        name="lastName"
                        label="שם משפחה"
                        required
                        autoComplete="family-name"
                      />
                    </StyledRowCol>
                    <StyledRowCol>
                      <FormInput
                        name="phoneNumber"
                        label="טלפון נייד"
                        autoComplete="tel-national"
                        required
                        type="tel"
                      />
                      <FormInput
                        name="email"
                        label="כתובת מייל"
                        autoComplete="email"
                        required
                        type="email"
                      />
                    </StyledRowCol>

                    <FormInput
                      name="message"
                      label="?איך נוכל לעזור"
                      multiline
                      minRows={4}
                    />
                    <StyledRowCol aria-label="אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה.">
                      <FormCheckBoxWithLable
                        name="approveMailingList"
                        label="אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה."
                      />
                    </StyledRowCol>

                    <StyledWrap>
                      <StyledButton
                        disabled={formik.isSubmitting}
                        fullWidth
                        variant="text"
                        type={"submit"}
                        disableFocusRipple={false}
                        disableRipple={false}
                      >
                        שליחה
                      </StyledButton>
                    </StyledWrap>
                  </StyledFormDiv>
                )}
              />
            )}
          </StyledWrapper>
          <ErrorInFormPopup
            open={formStatus === FormStatus.Error}
            onClose={() => setFormStatus(FormStatus.Normal)}
          />
        </>
        <ContactLinks />
      </InnerPageWrapper>
    </>
  )
}

export default ContactUsPage
